import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import images from '../../assets/images/dolphins';
export default function Dolphin(_ref) {
  var emotion = _ref.emotion,
      props = _objectWithoutProperties(_ref, ["emotion"]);

  return React.createElement("img", _extends({
    src: images[emotion],
    alt: emotion
  }, props));
}
Dolphin.propTypes = {
  emotion: PropTypes.string
};
Dolphin.defaultProps = {
  emotion: 'happy'
};